import { ValidatorFn, FormGroup, FormControl, AbstractControl } from '@angular/forms';
import { EntityType, Entity } from 'src/app/models/entities.model';


export class EntityValidators {
  constructor() { }

  static formValidator: ValidatorFn = (fg: FormGroup) => {
    const document = fg.get('document') ? EntityValidators.validateDocument(fg) : null;
    return EntityValidators.joinErrors(document);
  }

  static isCPF: ValidatorFn = (field: FormControl) => {
    const doc = field.value;
    if (!doc) { return null; }
    return EntityValidators.validateCPF(field.value);
  }

  static isCNPJ: ValidatorFn = (field: FormControl) => {
    const doc = field.value;
    if (!doc) { return null; }
    return EntityValidators.validateCNPJ(field.value);
  }

  static joinErrors(...errors: ({ isCNPJ?: boolean; birth?: string } | { isCPF: boolean; birth?: string })[]) {

    let ret = {};
    let hasError = false;
    errors.forEach(e => {
      if (e) {
        ret = { ...ret, ...e };
        hasError = true;
      }
    });
    if (!hasError) { return null; }
    return ret;
  }


  static validateDocument(fg: FormGroup) {
    const isCompany = fg.get('is_company').value;
    const document = fg.get('document').value;

    if (isCompany) {
      return EntityValidators.validateCNPJ(document);
    } else {
      return EntityValidators.validateCPF(document);
    }
  }

  static validateCPF(cpf: string) {

    let numbers: string;
    let digits: string;
    let sum: number;
    let i: number;
    let result: number;
    let equalDigits: number;

    equalDigits = 1;
    if (!cpf) { return null; }
    if (cpf.length > 0 && cpf.length < 11) {
      return { isCPF: true };
    }

    // Elimina CPFs invalidos conhecidos
    if (cpf == '00000000000' ||
      cpf == '11111111111' ||
      cpf == '22222222222' ||
      cpf == '33333333333' ||
      cpf == '44444444444' ||
      cpf == '55555555555' ||
      cpf == '66666666666' ||
      cpf == '77777777777' ||
      cpf == '88888888888' ||
      cpf == '99999999999') {
      return { isCPF: true };
    }

    for (i = 0; i < cpf.length - 1; i++) {
      if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
        equalDigits = 0;
        break;
      }
    }

    if (!equalDigits) {
      numbers = cpf.substring(0, 9);
      digits = cpf.substring(9);
      sum = 0;
      for (i = 10; i > 1; i--) {
        sum += parseInt(numbers.charAt(10 - i)) * i;
      }

      result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

      if (result !== Number(digits.charAt(0))) {
        return { isCPF: true };
      }
      numbers = cpf.substring(0, 10);
      sum = 0;

      for (i = 11; i > 1; i--) {
        sum += parseInt(numbers.charAt(11 - i)) * i;
      }
      result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

      if (result !== Number(digits.charAt(1))) {
        return { isCPF: true };
      }
      return null;
    } else {
      return { isCPF: true };
    }
  }

  static validateCNPJ(cnpj: string) {

    if (!cnpj || cnpj == '') { return null; }
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') { return { isCNPJ: true }; }

    if (cnpj.length != 14) {
      return { isCNPJ: true };
    }

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == '00000000000000' ||
      cnpj == '11111111111111' ||
      cnpj == '22222222222222' ||
      cnpj == '33333333333333' ||
      cnpj == '44444444444444' ||
      cnpj == '55555555555555' ||
      cnpj == '66666666666666' ||
      cnpj == '77777777777777' ||
      cnpj == '88888888888888' ||
      cnpj == '99999999999999') {
      return { isCNPJ: true };
    }

    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != parseInt(digitos.charAt(0))) {
      return { isCNPJ: true };
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != parseInt(digitos.charAt(1))) {
      return { isCNPJ: true };
    }

    return null;

  }

  static email: ValidatorFn = (field: AbstractControl) => {
    const email: string = field.value;
    if (!email) {
      return null;
    }

    const _at = email.split('@');
    if (_at.length < 2) {
      return {
        email: 'Email inválido 1'
      }
    }

    const _secondPart = _at[1].split('.');
    if (_secondPart.length < 2) {
      return {
        email: 'Email inválido 2'
      }
    }

    return null;
  }

}
